<template>
  <div v-if="!isEmptyPromoType && homeCategory?.url" :class="['shop-more', { 'shop-more--redesign': isProductPerksEnabledPhase2 }]">
    <ShopMore v-if="isShopMoreEnabled" :url="url" :label="label" />
    <ShopMoreExtended v-else-if="isShopMoreExtendedEnabled" :url="url" :label="label" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePromoType } from '@nuxt-common/media-card-large/app/modules/price';
import { useShopMore } from '@nuxt-common/media-card-large/app/modules/shop-more';
import useBreadcrumbs from '~/modules/breadcrumbs/composables/useBreadcrumbs';
import { getCategoryUrlWithPromoPlug, addCanvasAnchor } from '~/modules/breadcrumbs/utils';
import { useProductPrice } from '~/modules/price/composables/useProductPrice';
import useExperiments from '~/stores/useExperimentsStore';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import ShopMore from './ShopMore.vue';
import ShopMoreExtended from './ShopMoreExtended.vue';

const {
  experimentFlags: { isShopMoreStandardEnabled, isShopMoreExpandedEnabled },
} = useExperiments();
const { isProductPerksEnabledPhase2 } = useFeatureEligibility();

const isShopMoreEnabled = isShopMoreStandardEnabled;
const isShopMoreExtendedEnabled = isShopMoreExpandedEnabled;

const selectedPrice = useProductPrice();
const { homeCategory } = useBreadcrumbs();
const {
  killswitches: { isPDPEnhancementXEnabled },
} = useKillswitches();

const priceTypeText = computed(() => selectedPrice.value?.priceType?.text || '');
const promoEventBadgeUrl = computed(() => selectedPrice.value?.priceType?.promoEventBadgeUrl || '');
const priceFlags = computed(() => selectedPrice.value?.flags || {});
const promoCode = computed(() => selectedPrice.value?.lowestSalePriceTier?.promoCode || '');
const promoCodePromotionBadgeUrl = computed(() => selectedPrice.value?.lowestSalePriceTier?.promoEventBadgeUrl);
const promoUrl = computed(() => (promoCode.value ? promoCodePromotionBadgeUrl.value : promoEventBadgeUrl.value));

const categoryUrlWithPromoPlug = getCategoryUrlWithPromoPlug(homeCategory?.url);
const { promoType, isEmptyPromoType } = usePromoType({ priceTypeText, priceFlags });
const { label, url: uiGeneratedUrl } = useShopMore({
  promoType,
  promoCode,
  categoryUrlWithPromoPlug,
});
const url = computed(() => addCanvasAnchor(isPDPEnhancementXEnabled ? promoUrl.value : uiGeneratedUrl.value));
</script>

<style lang="scss" brand="mcom">
@import '~settingSCSS';

.shop-more {
  &.shop-more--redesign {
    .link-custom {
      padding-right: rem-calc(12px);

      &:hover {
        background-color: $hover-color;
      }
    }

    &:not(:first-child) {
      position: relative;
      &:before {
        position: absolute;
        content: '';
        top: -1px;
        left: 52px;
        width: calc(100% - 52px);
        height: 0.5px;
        background-color: $gray-2-color;
      }
    }
  }
}
</style>
